import { render, staticRenderFns } from "./AdminResumeDetail.vue?vue&type=template&id=d4d3a4fa&"
import script from "../../../services/admin/resume/admin-resume-detail.js?vue&type=script&lang=js&"
export * from "../../../services/admin/resume/admin-resume-detail.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports